export default __webpack_public_path__ + "static/media/401_error.17ae65ef.png";